import EventEmitter from "eventemitter3";
import {Power2, TimelineMax} from "gsap";
//https://stackoverflow.com/questions/4429440/html5-display-video-inside-canvas/38711016

export default class Videoplayer extends EventEmitter {

    constructor(viewport, src, id, options) {
        super();

        this.viewport = viewport;

        this.options = Object.assign({
            autoplay: false
        }, options);

        this.src = src;
        this.id = id;
        this.videoEl = document.getElementById('video_' + id);
        this.seconds = 0;   // length
        this.muted = true;  // !

        // Capture first frame
        this.videoEl.pause()

        // Initialise
        this._bindFn();
        this._initialiseCanvas();


        // Now we always play muted and leave the choice to the user. Quick and dirty (no more automated attempts)
        this._triggerUnmuteButton();
    }


    // ------------------------------------------------------------------------------------------------
    // Public
    // ------------------------------------------------------------------------------------------------


    play(fromStart) {
        console.log('Attempting to play', this.id)
        let self = this;
        if (fromStart) this.videoEl.currentTime = 0;
        ///
        if (this.options.skip) this.videoEl.currentTime = this.options.skip; // SKIP Dev

        let promise = this.videoEl.play();
        if (promise !== undefined) {
            promise.catch(error => {
                // Auto-play was prevented
                console.log('::: NO AUTOPLAY. ');
                // Show a Unmute/Play Button to let the user manually start playback
                setTimeout(() => {
                    // self._triggerUnmuteButton();
                    self.videoEl.muted = true;
                    self.videoEl.play();
                }, 1000)

            }).then(() => {
                // Auto-play started
                // self.videoEl.muted = false;  // No more force...
                self.videoEl.play();
            });
        }

    }

    pause() {
        this.videoEl.pause();
    }

    stop() {
        this.videoEl.pause();
        this.videoEl.src = '';
    }

    scrub(to) {

    }

    setSource(src) {
        this.src = src;
        this.videoEl.src = src;
    }

    /**
     * Restart video
     */
    restart() {
        // new TimelineMax()
        //     .to(this.canvas, 0.4, {
        //         opacity: 0, Ease: Power2.easeOut,
        //         onComplete: () => {
        //             this.videoEl.currentTime = 0;
        //         }
        //     })
        //     .call(() => {
        //         // this.videoEl.muted = false //
        //         let promise = this.videoEl.play();
        //     })
        //     .to(this.canvas, 0.4, {delay: 1, opacity: 1});

    }

    // ------------------------------------------------------------------------------------------------
    // Private
    // ------------------------------------------------------------------------------------------------

    _bindFn() {
        this._initialiseCanvas = this._initialiseCanvas.bind(this);
        this._addEvents = this._addEvents.bind(this);
        this._removeEvents = this._removeEvents.bind(this);
    }

    _debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }


    _initialiseCanvas() {
        // Set video ELEMENT.
        this.videoEl = document.getElementById('video_' + this.id);

        if (!this.videoEl) {
            // STOP.
            console.warn('NO VALID ID OR ELEMENT FOR VIDEOPLAYER')
        } else {
            // this.ctx = this.canvas.getContext('2d');
            this._addEvents(() => {
                // FadeOut?
                // if (this.options.fadeIn) TweenMax.set(this.canvas, {opacity: 0});
                // Set src - will cause flicker
                if (this.src)
                    this.videoEl.src = this.src;
            });
            // Attach resize listener
            this.viewport.on('viewport:resize', () => {
                this._debounce(this._arrangePlayer, 250)

            })
        }
    }


    /**
     * Arrange  canvases to the current window
     * DEPRECATED
     * @private
     */
    _arrangePlayer() {
        // 1920 x 1080 -> ratio : 1.777778
        const ratio = 1.777778;
        let cm, ctx, oldHeight, oldWidth, ratio1, ratio2

        // let canvases = $$('video')
        // $$(canvases).each((i, c) => {
        //     $$(c).css({
        //         "width": window.innerWidth,
        //         "height": window.innerHeight,
        //         "left": 1920 / 2 - window.innerWidth / 2,
        //         "top": 1080 / 2 - window.innerHeight / 2
        //     });
        //
        // })

    }

    /**
     * Video Events
     * @param callback
     * @private
     */
    _addEvents(callback) {
        let self = this;

        /**
         * Viewport has been resized
         */
        self.viewport.on('viewport:resize', () => {
            self._arrangePlayer();
        });

        // Initial Canvas size
        // set canvas size = video size when known
        this.videoEl.addEventListener('loadedmetadata', () => {
            self.videoEl.currentTime = 0;
            //
            self._arrangePlayer();
            // https://davidwalsh.name/html5-video-duration
            self.seconds = self.videoEl.duration;

        });

        /**
         * Video is buffered, emit READY event
         */
        this.videoEl.addEventListener('canplaythrough', () => {
            // Notify
            this.emit('video:ready');
            // this.videoEl.currentTime = 0.1  // Make sure we have something to see already
            if (self.options.autoplay && self.videoEl) {
                // if (this.options.fadeIn) TweenMax.to(this.canvas, 0.4, {opacity: 1});
                this.play();
            }
        });

        //
        // Play & LOOP!
        this.videoEl.addEventListener('play', function () {
            // let $this = this; //cache
            self.emit('video:play');
            self.video = this;
            // Show muted button
            // if (self.videoEl.muted) {
            //     self._triggerUnmuteButton();
            // }


        }, 0);

        // progress
        // this.videoEl.addEventListener('progress', function() {
        //    console.log(self.seconds, self.videoEl.currentTime)
        // });

        // Paused
        this.videoEl.addEventListener('pause', () => {
            self.emit('video:pause');
        });

        // Complete
        this.videoEl.addEventListener('ended', () => {
            self.emit('video:ended');
        });


        // Callback on ready
        callback()
    }

    /**
     * This button will show if there is no autoplay -- so the videos are playing muted
     * @private
     */
    _triggerUnmuteButton() {
        // return; // For now: NO mute button
        // -------------------------------
        // if (!this._hasAudio()) return;
        // if (!$$('#btn-mutmute').length) {
        //     // $$('#view').append('<a id="button_mute" style="bottom:5vh;"><img src="' + _TEMPLATEURI + '/assets/images/btn_unmute.svg" alt="unmute"/></a>');
        //     setTimeout(() => {
        //         // $('#button_mute').click()
        //     }, 500)
        // }
        // let tween = new TweenMax.fromTo('#button_mute', 0.32, {y:'100vh'}, {y: "60vh", ease: Power2.easeOut});
        $$('#btn-mute').on('click', (e) => {
            e.preventDefault();
            this.muted = !this.muted;
            this.videoEl.muted = this.muted;
            // Unmute all videos
            var videos = $$('video')
            videos.each((i,v)=>{
                v.muted = this.muted
            })

            if (this.muted)
                $$('#btn-mute').css('background-position-x', '40px')
            else
                $$('#btn-mute').css('background-position-x', '0px')
            // TweenMax.to('#button_mute', 0.32, {y: "100vh", ease: Power2.easeIn});
        })

    }

    _removeEvents() {
        this.videoEl.removeEventListener('loadedmetadata');
        this.videoEl.removeEventListener('play');
        this.videoEl.removeEventListener('ended');
        this.videoEl.removeEventListener('canplay');
    }

    // ------------------------------------------------------------------------------------------------
    // Utils
    // ------------------------------------------------------------------------------------------------

    /**
     * TODO: This is not working reliably
     * @returns {*|boolean}
     * @private
     */
    _hasAudio() {
        return this.videoEl.mozHasAudio ||
            Boolean(this.videoEl.webkitAudioDecodedByteCount) ||
            Boolean(this.videoEl.audioTracks && this.videoEl.audioTracks.length);
    }


    onDestroy() {
        this.removeEvents();
    }

}
